import { render, staticRenderFns } from "./blockOd.vue?vue&type=template&id=15396f32&scoped=true&"
import script from "./blockOd.vue?vue&type=script&lang=js&"
export * from "./blockOd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15396f32",
  null
  
)

export default component.exports